import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoDirective } from '@ngneat/transloco';

@Component({
  selector: 'pxw-product-option-selector-wrapper',
  templateUrl: './product-option-selector-wrapper.component.html',
  styleUrls: ['./product-option-selector-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslocoDirective],
})
export class ProductOptionSelectorWrapperComponent {
  name = input.required<string>();
  instructions = input.required<string>();

  isOptional = input<boolean>();
  isRequired = input<boolean>();
}
